exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-reenviar {\n}\n@media (min-width: 993px) {\n  .btn-reenviar {\n    margin-right: 5px;\n  }\n}\n@media (max-width: 992px) {\n  .btn-reenviar {\n    margin-bottom: 5px;\n  }\n}\n", ""]);

